import { KalturaClient } from '@kaltura-ott/rxjs-ott-client';
import { Observable } from 'rxjs';

import { getConfig, KuxConfig, KuXConfig } from './config';

let client: KalturaClient | null = null;
let originalRequest: KalturaClient['request'];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyFunction = (...args: any[]) => any;

export type MiddlewareFunc = <T, Func extends AnyFunction>(
  originalRequest: Func,
  ...args: Parameters<Func>
) => (source: Observable<T>) => Observable<unknown>;

const middlewares: Array<MiddlewareFunc> = [];

function attachMiddlewares() {
  if (client) {
    client.request = <T>(...args: Parameters<KalturaClient['request']>): ReturnType<KalturaClient['request']> => {
      return middlewares.reduce(
        (observable, middleware) => observable.pipe(middleware<T, KalturaClient['request']>(originalRequest, ...args)),
        originalRequest<T>(...args),
      );
    };
  }
}

export function addMiddleware(fn: MiddlewareFunc) {
  const index = middlewares.push(fn) - 1;
  attachMiddlewares();
  return () => {
    middlewares.splice(index, 1);
    attachMiddlewares();
  };
}

export const kalturaClient: () => KalturaClient = () => {
  const config: KuxConfig = getConfig(KuXConfig)('');

  if (!client) {
    client = new KalturaClient();
    originalRequest = client.request.bind(client);
    attachMiddlewares();
  }

  client.appendOptions(config);

  // backend don't allow ks: '', or remove it from headers for now
  client.appendDefaultRequestOptions({
    ks: config.ks || undefined,
    language: config.language || '*',
  });

  return client;
};
